import {
  BorrowInsert,
  GetBorrow, GetBorrowAmountMax,
} from "./api";

import http from "config/http";

const borrowApi = {
  getBorrow: async ({ basketOwnerId = 1, coinId = -1 }) => await http.get(GetBorrow({ basketOwnerId, coinId })),

  getBorrowAmountMax: async ({ basketOwnerId, coinId }) => await http.get(GetBorrowAmountMax({ basketOwnerId, coinId })),

  borrowInsert: async (body) => await http.post(BorrowInsert, body),
};

export default borrowApi;
